// React
import React from 'react';

// Prime React
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Planner functions
import { formatDate, getEmployeeLink, getTravellerLink, getProductHTML, getOrderLink, getEditButton } from '../planner/planner';

// Additional imports
import { decode } from 'html-entities';

import { Link } from 'react-router-dom';

import { Tooltip } from 'primereact/tooltip';


export function BomTable(props) {

	/**
	 * If the stock is less than the quantity required for the order, add shortage badge with the quantity needed
	 * 
	 * @param {Object} rowData Data for the current row
	 * @returns {html} Adds shortage badge on material name if applicable
	 */
	function getShortages(rowData) {
		if((rowData.shortage) || rowData.id == null) {
			return <>
				<Tooltip autohide={false} target=".material-description" />
				{
					props.capabilities.edit_products && (
						<span data-pr-tooltip={rowData.material_name} className="material-description"><Link to={"/product/" + rowData.material_id}>{rowData.material_sku}</Link></span>
					)
				}
				{
					!props.capabilities.edit_products && (
						<span data-pr-tooltip={rowData.material_name} className="material-description"><span>{rowData.material_sku}</span></span>			)
				}
			</>
		}
	}

	function getQuantity(rowData) {
		return rowData.material_qty;
	}

	function getStock(rowData) {
		return rowData.material_stock;
	}

	function getCategory(rowData) {
		let badgeColor = 'bg-primary';

		if(rowData.material_cat_name === 'Uncategorised') {
			badgeColor = 'bg-danger';
		}

		return <span className={"badge " + badgeColor}>{rowData.material_cat_name}</span>
	}

	function getAverageCostPrice(rowData) {
		return decode(rowData.average_cost_price);
	}

	function getAverageNet(rowData) {
		return decode(rowData.average_net);
	}

	// List of all possible columns
	let columns = [
		{
			name: 'sku',
			header: 'Material',
			sortable: false,
			output: getShortages,
			capability: true
		},
		{
			name: 'quantity',
			header: 'Quantity',
			sortable: false,
			output: getQuantity,
			capability: true
		},
		{
			name: 'stock',
			header: 'Stock',
			sortable: false,
			output: getStock,
			capability: true
		},
		{
			name: 'category',
			header: 'Category',
			sortable: false,
			output: getCategory,
			capability: true
		},
		{
			name: 'average_cost_price',
			header: 'Average Cost Price',
			sortable: false,
			output: getAverageCostPrice,
			capability: props.capabilities.read_products
		},
		{
			name: 'average_net',
			header: 'Average Net',
			sortable: false,
			output: getAverageNet,
			capability: props.capabilities.read_products
		},
	]

	return (
		<DataTable value={props.bom}>
			{
				columns.map(column => {
					return props.columns.includes(column.name) && column.capability == true && (
						<Column key={column.name} field={column.name} header={column.header} sortable={column.sortable} body={column.output} />
					)
				})
			}
		</DataTable>
	)
}